export const SET_CONFIG = "SET_CONFIG";
export const setPayload = (data) => ({
  type: SET_CONFIG,
  data: data,
});
